const ServiceHistory = () => import('./History')
const ServiceCenters = () => import('./Centers')

export default function Components(Vue) {
  Vue.component('service-history', ServiceHistory)
  Vue.component('service-centers', ServiceCenters)
}
